import { render, staticRenderFns } from "./enseignantWidget.vue?vue&type=template&id=05b2d3cc&scoped=true&lang=pug&"
import script from "./enseignantWidget.vue?vue&type=script&lang=js&"
export * from "./enseignantWidget.vue?vue&type=script&lang=js&"
import style0 from "./enseignantWidget.vue?vue&type=style&index=0&id=05b2d3cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2d3cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VList,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
